import { frontendURL } from '../../../helper/URLHelper';
import PessoasView from './PessoasView.vue';
import RegistrosView from './RegistrosView.vue';
import AttendanceTypesView from './AttendanceTypesView.vue';
import SpecialtiesView from './SpecialtiesView.vue';
import AttendancePricesView from './AttendancePricesView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm/pessoas'),
    name: 'crm_pessoas',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: PessoasView,
  },
  {
    path: frontendURL('accounts/:accountId/crm/registros'),
    name: 'crm_registros',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: RegistrosView,
  },
  {
    path: frontendURL('accounts/:accountId/crm/tipos-atendimento'),
    name: 'crm_attendance_types',
    meta: {
      permissions: ['administrator'],
    },
    component: AttendanceTypesView,
  },
  {
    path: frontendURL('accounts/:accountId/crm/especialidades'),
    name: 'crm_specialties',
    meta: {
      permissions: ['administrator'],
    },
    component: SpecialtiesView,
  },
  {
    path: frontendURL('accounts/:accountId/crm/valores-atendimento'),
    name: 'crm_attendance_prices',
    meta: {
      permissions: ['administrator'],
    },
    component: AttendancePricesView,
  },
];
